<!--异常关闭状态Column -->
<template>
    <div>
        <i v-if="row['status'] === 1" class="el-icon-circle-check" style="color: green"></i>
        <i v-else class="el-icon-circle-close" style="color: red"></i>
    </div>
</template>

<script>
export default {
    props: ['row'],
    data() {
        return {

        }
    },
}
</script>